import { attributesConditionsMatch } from 'shared-helpers/customAttributes';

import type { RequestUser, UserCustomAttribute } from 'shared-types';

const canUserCustomAttributeBeEditedInSettings = (
  user: RequestUser,
  userCustomAttribute: UserCustomAttribute
) => {
  if (
    user?.roles.includes('superadmin') &&
    userCustomAttribute.permissions?.editSettings.superadmin.value
  ) {
    return userCustomAttribute.permissions.editSettings.superadmin.conditions
      ?.length
      ? attributesConditionsMatch({
          conditions:
            userCustomAttribute.permissions.editSettings.superadmin.conditions,
          user,
          customAttributeValues: user.customAttributes
        })
      : true;
  }

  if (
    user?.roles.includes('admin') &&
    user?.permissions?.includes('edit-user-custom-attributes') &&
    !user.roles.includes('superadmin') &&
    userCustomAttribute.permissions?.editSettings.admin.value
  ) {
    return userCustomAttribute.permissions.editSettings.admin.conditions?.length
      ? attributesConditionsMatch({
          conditions:
            userCustomAttribute.permissions.editSettings.admin.conditions,
          user,
          customAttributeValues: user.customAttributes
        })
      : true;
  }

  return false;
};

export default canUserCustomAttributeBeEditedInSettings;
